/* PRIETT — real-time AJAX cart (minicart drawer + cart page).
   Updates the DOM IN PLACE from the /cart/change.js JSON response — it never
   re-renders / reloads the whole cart. Qty changes are optimistic (instant),
   network is debounced + serialized, the slim top progress bar shows activity,
   and removed lines animate out. Going empty falls back to a one-time re-render
   so the empty state shows. Uses event delegation so refreshed markup keeps working. */
(function () {
  if (window.__priettCartAjax) return;
  window.__priettCartAjax = true;

  function fmt(cents) {
    return '$' + (Number(cents) / 100).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* ---- in-place UI update from cart JSON ---- */
  function updateUI(cart) {
    var byKey = {};
    cart.items.forEach(function (it) { byKey[it.key] = it; });

    // count badges + drawer title
    document.querySelectorAll('[data-pe-cart-count]').forEach(function (b) {
      var changed = String(cart.item_count) !== String(b.textContent).trim();
      b.textContent = cart.item_count;
      if (cart.item_count > 0) { b.hidden = false; b.style.display = ''; if (changed) { b.classList.remove('pe-pop'); void b.offsetWidth; b.classList.add('pe-pop'); } }
      else { b.hidden = true; b.style.display = 'none'; }
    });
    document.querySelectorAll('[data-mc-count]').forEach(function (e) {
      e.textContent = '(' + cart.item_count + ' ' + (cart.item_count === 1 ? 'artículo' : 'artículos') + ')';
    });
    document.querySelectorAll('[data-cart-count-label]').forEach(function (e) {
      e.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'prenda' : 'prendas');
    });

    // line items: update in place, animate-out removed ones
    document.querySelectorAll('[data-line-key]').forEach(function (line) {
      var it = byKey[line.getAttribute('data-line-key')];
      if (!it) { animateRemove(line); return; }
      var disp = line.querySelector('[data-qty-display]');
      if (disp) disp.textContent = it.quantity;
      var inp = line.querySelector('input[data-cart-key]');
      if (inp && document.activeElement !== inp) inp.value = it.quantity;
      var lp = line.querySelector('[data-line-price]');
      if (lp) lp.textContent = fmt(it.final_line_price);
      line.setAttribute('data-unit-price', it.final_price);
      line.classList.remove('is-changing');
    });

    // totals
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (e) { e.textContent = fmt(cart.items_subtotal_price); });
    document.querySelectorAll('[data-cart-total]').forEach(function (e) { e.textContent = fmt(cart.total_price); });
    document.querySelectorAll('[data-checkout-total]').forEach(function (e) { e.textContent = fmt(cart.total_price); });

    // free-ship progress
    document.querySelectorAll('[data-ship]').forEach(function (s) {
      var th = parseInt(s.getAttribute('data-ship-threshold'), 10) || 0;
      var rem = Math.max(0, th - cart.total_price);
      var pct = th > 0 ? Math.min(100, cart.total_price * 100 / th) : 100;
      var fill = s.querySelector('[data-ship-fill]'); if (fill) fill.style.width = pct + '%';
      var msg = s.querySelector('[data-ship-msg]');
      if (msg) msg.innerHTML = rem > 0
        ? 'Ya casi, agrega <strong>' + fmt(rem) + '</strong> más para obtener <strong>¡ENVÍO GRATIS!</strong>'
        : '<strong>¡Listo!</strong> Tu pedido tiene envío gratis.';
    });

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

    // going empty → re-render so the empty state shows
    if (cart.item_count === 0) {
      if (window.__priettHeader && window.__priettHeader.refreshCart) window.__priettHeader.refreshCart();
      var pageSec = document.querySelector('[data-cart-section-id]');
      if (pageSec) refreshSection(pageSec.getAttribute('data-cart-section-id'));
    }
  }

  function animateRemove(line) {
    var h = line.offsetHeight;
    line.style.overflow = 'hidden';
    line.style.height = h + 'px';
    line.style.transition = 'opacity .22s ease, height .3s ease, margin .3s ease, padding .3s ease, transform .25s ease';
    requestAnimationFrame(function () {
      line.style.opacity = '0'; line.style.transform = 'translateX(8px)';
      line.style.height = '0'; line.style.marginTop = '0'; line.style.marginBottom = '0';
      line.style.paddingTop = '0'; line.style.paddingBottom = '0'; line.style.borderWidth = '0';
    });
    setTimeout(function () { line.remove(); }, 320);
  }

  function refreshSection(id) {
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) { var w = document.getElementById('shopify-section-' + id); if (w && html) w.innerHTML = html; })
      .catch(function () {});
  }

  /* ---- network: serialized, with the top progress bar ---- */
  var inflight = 0;
  function send(key, qty) {
    inflight++;
    if (window.PriettUX) window.PriettUX.start();
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateUI(cart); })
      .catch(function () {})
      .then(function () { inflight--; if (window.PriettUX) window.PriettUX.done(); });
  }

  // debounced per-line so rapid taps feel instant but only the final qty is sent
  var timers = {};
  function queueChange(key, qty, immediate) {
    clearTimeout(timers[key]);
    if (immediate) { send(key, qty); return; }
    timers[key] = setTimeout(function () { send(key, qty); }, 240);
  }

  function lineFor(el) { return el.closest('[data-line-key]'); }
  function currentQty(line) {
    var d = line && (line.querySelector('[data-qty-display]') || line.querySelector('input[data-cart-key]'));
    if (!d) return 1;
    return parseInt(d.value != null && d.tagName === 'INPUT' ? d.value : d.textContent, 10) || 0;
  }

  // qty +/- and remove (delegated)
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-cart-key][data-qty-role]');
    if (!el) return;
    e.preventDefault(); e.stopPropagation();
    var key = el.getAttribute('data-cart-key');
    var role = el.getAttribute('data-qty-role');
    var line = lineFor(el);
    if (role === 'remove') {
      if (line) line.classList.add('is-changing');
      queueChange(key, 0, true);
      return;
    }
    var cur = line ? currentQty(line) : 1;
    var next = role === 'inc' ? cur + 1 : cur - 1;
    if (next < 1) { // dec to 0 = remove
      queueChange(key, 0, true); if (line) line.classList.add('is-changing'); return;
    }
    // optimistic: update qty + line price instantly
    if (line) {
      var disp = line.querySelector('[data-qty-display]'); if (disp) disp.textContent = next;
      var inp = line.querySelector('input[data-cart-key]'); if (inp) inp.value = next;
      var unit = parseInt(line.getAttribute('data-unit-price'), 10);
      var lp = line.querySelector('[data-line-price]');
      if (lp && unit) lp.textContent = fmt(unit * next);
    }
    queueChange(key, next);
  });

  // qty number input (cart page)
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('input[data-cart-key]');
    if (!inp) return;
    var q = parseInt(inp.value, 10); if (isNaN(q) || q < 0) q = 0;
    queueChange(inp.getAttribute('data-cart-key'), q, true);
  });
})();
